module.exports = __webpack_public_path__ + "static/media/icon2u.b26de0e2.svg";